/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'feedback-positive_big': {
    width: 16,
    height: 16,
    viewBox: '0 0 140 140',
    data: '<g _fill="none" fill-rule="evenodd"><g _fill="#FFF"><g><g><path pid="0" d="M62.952 95.367l.094.094L104 54.507l-5.802-5.802L62.952 83.95 47.802 68.8 42 74.602 62.859 95.46l.093-.094zM70 140c-38.66 0-70-31.34-70-70S31.34 0 70 0s70 31.34 70 70-31.34 70-70 70z"/></g></g></g></g>'
  }
})
